/* packages/volto-castle-theme/src/components/Blocks/HPFeatures/index.ts */
import View from './view';
import schema from './schema';
import icon from '@plone/volto/icons/grid.svg';

export default {
  id: 'hp_features',
  title: 'HP Features',
  icon: icon,
  group: 'homepage',
  view: View,
  schema: schema
};
